module.exports = __webpack_public_path__ + "static/img/physical_harm.9e8aa768.png";